import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { FormBuilder } from "@formio/react";
// css
import "./Templatepage.css";
import 'formiojs/dist/formio.full.min.css'; // Essential Form.io styles
// custom imports
import { HandleApiError } from "../../../Utils/CommonErrors/HandleApiError";
import showToast from "../../../Utils/Toast/ToastNotification";
import { hideLoader, showLoader } from "../../../Redux/Slice/Loader/loaderSlice";
import TemplateService from "../../../Services/TemplateService/TemplateService"

const Templatepage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [formData, setformData] = useState([])
  const created_by = useSelector(
    (state) => state.auth.user.data?.body?.data?.userData?.id
  );
  const token = useSelector(
    (state) => state.auth.user.data?.body?.data?.token
  );

  const [formSchema, setFormSchema] = useState({
    display: 'form',
    components: []
  });

  const [templateData, setTemplateData] = useState({
    template_name: '',
    description: '',
    tags: [],
    form_data: {},
    created_by: created_by
  });
  const [errors, setErrors] = useState({});


  const handleChange = (e) => {
    const { name, value } = e.target;

    if (errors[name]) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: null,  // Clear error for the field being updated
      }));
    }

    if (name === "tags") {
      const tagsArray = value.split(',').map(tag => tag.trim());
      setTemplateData({ ...templateData, tags: tagsArray });
    } else {
      setTemplateData({ ...templateData, [name]: value });
    }
  };

  const temaplateSchema = Yup.object({
    template_name: Yup.string().required("template Name is required"),
    description: Yup.string().required("Description is Required"),
  });

  // by default storage set to azure

  const patchFormComponents = (components, token) => {
    return (components || []).map((component) => {
      if (!component || typeof component !== 'object') return component;

      // Recursively patch nested structures first
      const patchChildren = (key) => {
        return (component[key] || []).map((item) => ({
          ...item,
          components: patchFormComponents(item.components || [], token),
        }));
      };

      let patchedComponent = { ...component };

      if (component.components) {
        patchedComponent.components = patchFormComponents(component.components, token);
      }

      if (component.columns) {
        patchedComponent.columns = patchChildren('columns');
      }

      if (Array.isArray(component.rows)) {
        patchedComponent.rows = component.rows.map((row) =>
          Array.isArray(row)
            ? row.map((col) => ({
              ...col,
              components: patchFormComponents(col.components || [], token),
            }))
            : []
        );
      }

      // Patch for file field
      // if (component.type === 'file') {
      //   patchedComponent = {
      //     ...patchedComponent,
      //     // storage: 'azure',
      //     options: {
      //       ...(patchedComponent.options || {}),
      //       storageOptions: {
      //         ...(patchedComponent.storageOptions || {}),
      //         url: '', // Put your Azure Blob endpoint here if needed
      //       },
      //     },
      //   };
      // }
      if (component.type === 'file') {
        patchedComponent = {
          ...patchedComponent,
          storage: 'base64', // ✅ tell Form.io to store files as Base64
          options: {
            ...(patchedComponent.options || {}),
          },
        };
      }

      // Patch for select with dataSrc: 'url'
      if (component.type === 'select' && component.dataSrc === 'url') {
        patchedComponent = {
          ...patchedComponent,
          data: {
            ...(patchedComponent.data || {}),
            headers: [
              { key: 'Content-Type', value: 'application/json' },
              { key: 'Authorization', value: `Bearer ${token}` },
            ],
          },
        };
      }

      if (component.type === 'editgrid') {
        patchedComponent = {
          ...patchedComponent,
          templates: {
            ...(patchedComponent.templates || {}),
            header:
              `<div class="row bg-light p-2 rounded">
                {% util.eachComponent(components, function(component) { %}
                  {% if (displayValue(component)) { %}
                    <div class="d-none col-sm-2">{{ t(component.label) }}</div>
                  {% } %}
                {% }) %}
              </div>`,
            row:
              `<div class="editgrid-inner-wrapper {{ true ? '' : 'hide-entire-row' }}">
                <div class="col-12">
                  <div class="p-3 bg-light border border-3 border-secondary rounded-3 shadow-sm">
                    <div class="row">
                      {% util.eachComponent(components, function(component) { %}
                        {% if (displayValue(component)) { %}
                          <div class="col-12 mb-2">
                            <div class="fw-bold">{{ component.label }}</div>
                            <div class="text-body">
                              {{ isVisibleInRow(component) ? getView(component, row[component.key]) : '—' }}
                            </div>
                          </div>
                        {% } %}
                      {% }) %}
  
                      {% if (!instance.options.readOnly && !instance.disabled) { %}
                        <div class="col-12 mt-2">
                          <div class="row g-2">
                            <div class="col-12 col-md-auto">
                              <button class="btn btn-primary px-4 py-2 shadow w-100 editRow">
                                <i class="{{ iconClass('edit') }}"></i> Edit
                              </button>
                            </div>
                            {% if (!instance.hasRemoveButtons || instance.hasRemoveButtons()) { %}
                              <div class="col-12 col-md-auto">
                                <button class="btn btn-danger px-4 py-2 shadow w-100 removeRow">
                                  <i class="{{ iconClass('trash') }}"></i> Delete
                                </button>
                              </div>
                            {% } %}
                          </div>
                        </div>
                      {% } %}
                    </div>
                  </div>
                </div>
              </div>`,
            addButton:
              `let hasActiveRow = false;
              if (instance && Array.isArray(instance.editRows)) {
                hasActiveRow = instance.editRows.some(row =>
                  row.state === 'editing' || row.state === 'new'
                );
              }
              show = !hasActiveRow;`,
          },
        };
      }


      return patchedComponent;
    });
  };

  const handleFormChange = (schema) => {
    try {
      // Store schema as-is without patching
      setFormSchema(schema);
      setTemplateData((prevData) => ({
        ...prevData,
        form_data: schema,
      }));
    } catch (err) {
      HandleApiError(err);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});
    dispatch(showLoader());

    try {
      // Patch form data right before validation + submission
      const patchedForm = {
        ...formSchema,
        components: patchFormComponents(formSchema.components || [], token),
      };

      const finalTemplateData = {
        ...templateData,
        form_data: patchedForm,
      };

      await temaplateSchema.validate(finalTemplateData, { abortEarly: false });

      const response = await TemplateService.createTemplate(finalTemplateData, token);

      if (response.data?.statusCode === 200) {
        showToast("success", response?.data?.body?.message);
        setTemplateData({
          template_name: '',
          description: '',
          tags: [],
          form_data: {}
        });
        setFormSchema({
          display: 'form',
          components: []
        });
        navigate(-1);
      } else {
        showToast("error", response?.data?.body?.message);
      }
    } catch (error) {
      if (error.name === "ValidationError") {
        const newErrors = {};
        error.inner.forEach((err) => {
          newErrors[err.path] = err.message;
        });
        setErrors(newErrors);
      } else {
        HandleApiError(error);
      }
    } finally {
      dispatch(hideLoader());
    }
  };


  const getDefaultTemplate = async () => {
    try {
      const response = await TemplateService.getdefaultTemplate(token)
      setformData(response?.data?.body?.data[0]?.values?.components)

    } catch (error) {
      HandleApiError(error)
    }
  }
  useEffect(() => {
    getDefaultTemplate()
  }, [])

  return (

    <div className="main-inner-block">
      <form
        onSubmit={handleSubmit}
        onKeyDown={(e) => e.key === "Enter" && e.preventDefault()}
      >
        <div className="content">
          <div className='d-flex align-items-center justify-content-between mb-4 block-one'>
            <div className='heading-content mt-0'>
              Create Template
            </div>
            <div className='text-center update-div d-flex align-items-center justify-content-center gap-2 mt-0'>
              <button
                type="submit"
                className='green-btn green-signin addnewuser'

              >
                Save
              </button>
              <button
                type="button"
                className='green-btn green-signin addnewuser'
                // style={{ marginLeft: '10px' }}
                onClick={() => navigate(-1)}
              >
                Cancel
              </button>
            </div>
          </div>

          <div className="white-box">
            <div class="d-flex gap-3 create-user-block w-100 justify-content-between">
              <div className="row m-0 w-100 justify-content-between">
                <div class="mb-3 col-md-4">
                  <label for="TemplateName" class="form-label">
                    Template Name <span>*</span>
                  </label>
                  <input
                    type="text"
                    name="template_name"
                    class="form-control"
                    id="TemplateName"
                    placeholder="Template name"
                    value={templateData.template_name}
                    onChange={handleChange}
                  />
                  {errors.template_name && (
                    <div className="text-danger mt-1">{errors.template_name}</div>
                  )}
                </div>

                <div class="mb-3 col-md-4">
                  <label for="description" class="form-label">
                    Description <span>*</span>
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    name="description"
                    id="description"
                    placeholder="Description"
                    value={templateData.description}
                    onChange={handleChange}

                  />
                  {errors.description && (
                    <div className="text-danger mt-1">{errors.description}</div>
                  )}
                </div>

                <div className="mb-3 col-md-4">
                  <label htmlFor="tag" className="form-label">
                    Tag
                  </label>
                  <div className="tag-input-wrapper">
                    {templateData.tags.map((tag, index) => (
                      <span key={index} className="tag-pill">
                        {tag}
                        <button
                          type="button"
                          className="tag-remove-btn"
                          onClick={() => {
                            const updatedTags = [...templateData.tags];
                            updatedTags.splice(index, 1);
                            setTemplateData({ ...templateData, tags: updatedTags });
                          }}
                        >
                          ×
                        </button>
                      </span>
                    ))}
                    <input
                      type="text"
                      className="tag-input"
                      placeholder="Type and press Enter"
                      onKeyDown={(e) => {
                        if (e.key === "Enter" && e.target.value.trim()) {
                          e.preventDefault();
                          const newTag = e.target.value.trim();
                          if (!templateData.tags.includes(newTag)) {
                            setTemplateData({
                              ...templateData,
                              tags: [...templateData.tags, newTag],
                            });
                          }
                          e.target.value = "";
                        }
                      }}
                    />
                  </div>
                </div>


              </div>
            </div>
          </div>
        </div>
        <div className="heading-content">Form Builder</div>
        <div className="content">
          <div className="white-box">
            <FormBuilder
              form={{ components: formSchema.components }}
              onChange={handleFormChange}
            />
          </div>
        </div>
      </form>
    </div >

  );
};

export default Templatepage;

